/*
 * Simplinsur
 * Author: Victor Tihai, WPlook Studio
 */

// Import Bootstrap
import { Util, Dropdown, Offcanvas, Popover, Button, Modal } from 'bootstrap';

// Marketing material PDF generation
import './marketing-pdf.js';

// Lead form: validation + AJAX submit
import './submit-handler.js';
